import LocationVisitsNotice from "./location-visits-notice";

export default LocationVisitsNotice;